import { ca } from '@cian/analytics';

export function trackFavoritesIconClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'top_menu',
    label: 'favorites',
  });
}
